// removed by extract-text-webpack-plugin
module.exports = {"image_compare_box_wrapper":"ImageCompareBox--image_compare_box_wrapper--LBYL-","image_compare_box":"ImageCompareBox--image_compare_box--2KXUt","image_compare_box_item":"ImageCompareBox--image_compare_box_item--v2qVk","image_compare_box_image":"ImageCompareBox--image_compare_box_image--1rKHS","image_compare_box_content":"ImageCompareBox--image_compare_box_content--1VZmV"};


//////////////////
// WEBPACK FOOTER
// /src/~/@healthwise/enhanced-shared-decision-point/components/ImageCompareBox/ImageCompareBox.css
// module id = 1022
// module chunks = 0